import React from 'react';
import {TableCell} from 'material-ui';
import TagTranslationsTableItemActionEdit from './TagTranslationsTableItemActionEdit';
import TagTranslationsTableItemActionDelete from './TagTranslationsTableItemActionDelete';
import {canDeleteTranslationOrNot} from '../../../components/permissions/permissions';

class TagTranslationsTableItemActions extends React.Component {

    render() {
        const {
            tagTranslation,
            classes,
            tag,
            editing,
            handleClickOpen,
            tagTranslationBySite,
            createTagTranslation,
            updateTagTranslation,
            cancelUpdateTagTranslation,
            siteId,
            newTranslated
        } = this.props;

        const DeleteTranslationButton = () => (
            <TagTranslationsTableItemActionDelete
                classes={classes}
                handleClickOpen={handleClickOpen}
                tagTranslation={tagTranslation}
                tagId={tag.id}
            />
        )

        const CannotDeleteTranslation = () => (
            <span>
               No available actions!
            </span>
        )

        let CanDeleteTranslationOrNot = canDeleteTranslationOrNot(DeleteTranslationButton, CannotDeleteTranslation); 

        return (
            <TableCell width={120} className={classes.tableCell}>
                <span id="buttons">
                    {editing &&
                        <TagTranslationsTableItemActionEdit
                            classes={classes}
                            tag={tag}
                            newTranslated={newTranslated}
                            siteId={siteId}
                            tagTranslation={tagTranslation}
                            createTagTranslation={createTagTranslation}
                            updateTagTranslation={updateTagTranslation}
                            cancelUpdateTagTranslation={cancelUpdateTagTranslation}
                            tagTranslationBySite={tagTranslationBySite}
                        />
                    }
                    {tagTranslation !== null && <CanDeleteTranslationOrNot />}
                </span>
            </TableCell>
        )
    }
};

export default TagTranslationsTableItemActions;


// WEBPACK FOOTER //
// ./src/containers/tags/translations/TagTranslationsTableItemActions.jsx